import React, { useEffect } from "react";
import CheckEligibility from "../views/eligibilityCheck/check_eligibility";
import StmSummary from "../views/shared/storefront-summary";

const EligibilityCheckUI = (props) => {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [])

  return (
    <div className="storefront-two-col-pg">
      <CheckEligibility history={props.history} />
      <StmSummary />
    </div>
  );
};

export default EligibilityCheckUI;
